import styled from 'styled-components';

export const TextEditorWrapper = styled.div`
  .ql-editor {
    height: 120px;
    border-top: 0px;
    background-color: ${({ theme }) => theme.palette.backgrounds.main};
  }

  .ql-toolbar.ql-snow {
    border: ${({ theme }) => `1px solid ${theme.palette.borderColor}`};
  }
`;
